import React, { useEffect, useState } from 'react';
import { GetClaimsList } from '../../../api/home';
import { useQuery } from '@tanstack/react-query';

export default function useClaims(claims) {
  const [claimsValues, setClaimsValues] = useState();

  const getClaims = useQuery({
    queryKey: ['claims', claims],
    queryFn: async () => await GetClaimsList({ Claims: claims })(),
  });

  // Handle success with useEffect
  useEffect(() => {
    if (getClaims.isSuccess && getClaims.data) {
      setClaimsValues(getClaims.data);
    }
  }, [getClaims.isSuccess, getClaims.data]);

  // Handle error with useEffect
  useEffect(() => {
    if (getClaims.isError) {
      console.log('failure');
    }
  }, [getClaims.isError]);

  return claimsValues;
}
